"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBPropertyBuyNegative = function SvgBPropertyBuyNegative(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M3.171 142.601a2.416 2.416 0 01-2.369-2.567L7.824 29.549a6.227 6.227 0 016.184-5.822l19.207-.051a2.416 2.416 0 011.717 4.117 2.413 2.413 0 01-1.705.71l-19.215.052c-.73-.001-1.335.566-1.382 1.295L5.782 137.763l20.116-.051a2.413 2.413 0 11.012 4.828l-22.674.063-.065-.002zM55.998 28.443a2.414 2.414 0 01.036-4.827l33.078-.09h.049a2.414 2.414 0 11-.036 4.827l-33.079.09h-.048zM98.118 142.344a2.414 2.414 0 01-2.372-2.407l-.067-26.601a2.413 2.413 0 01.698-1.71 2.462 2.462 0 011.71-.71l8.85-.023a.21.21 0 00.229-.149.241.241 0 00-.052-.274L65.99 69.523a2.413 2.413 0 113.407-3.417l41.124 40.948a5.068 5.068 0 01-3.563 8.651l-6.437.017.055 21.773 29.248-.077-7.467-107.857a1.4 1.4 0 00-1.393-1.312l-19.247.067-.048-.001a2.414 2.414 0 11.036-4.827l19.247-.067.16.003a6.227 6.227 0 016.087 5.787l7.655 110.451a2.413 2.413 0 01-.643 1.807c-.454.49-1.091.77-1.76.774l-34.237.086-.096.015z"
  }), (0, _core.jsx)("path", {
    d: "M37.296 142.505a2.413 2.413 0 01-1.662-.697 2.413 2.413 0 01-.71-1.71l-.06-24.187-6.035.015a5.237 5.237 0 01-3.731-8.915l33.086-33.264a2.415 2.415 0 013.425 3.407l-33.087 33.264a.362.362 0 00-.088.449.362.362 0 00.382.248l8.449-.022a2.413 2.413 0 012.412 2.408l.068 24.187 17.96-.04-.062-24.14a2.413 2.413 0 012.4-2.435l15.288-.04a2.413 2.413 0 012.42 2.408l.061 24.14 8.924-.022a2.413 2.413 0 11.012 4.828l-11.337.027a2.413 2.413 0 01-2.437-2.36l-.062-24.138-10.46.026.062 24.139a2.413 2.413 0 01-2.408 2.412l-22.787.06-.023-.048zM44.662 43.597a2.413 2.413 0 01-2.372-2.407l-.033-15.12a25.204 25.204 0 1150.402-.133l.033 15.15a2.414 2.414 0 01-2.4 2.42h-.056a2.413 2.413 0 01-2.372-2.407l-.041-15.151C87.576 14.856 78.499 6 67.404 6.026c-11.095.025-20.13 8.923-20.327 20.016l.041 15.151a2.413 2.413 0 01-2.408 2.42l-.048-.016z"
  })));
};

var _default = SvgBPropertyBuyNegative;
exports["default"] = _default;